import React from 'react';
import Services from '../components/Services';
import WhyChooseUs from '../components/WhyChooseUs';

const ServicesPage = () => {
  return (
    <>
      <Services />
      <WhyChooseUs />
    </>
  );
};

export default ServicesPage;
